import { UtilityProgramViewConfig } from '.'

export function getWhilelabeledExperienceData(
  viewConfig: UtilityProgramViewConfig,
) {
  return {
    colorScheme: viewConfig.colorScheme,
    brandLogo: viewConfig.bannerLogoUrl,
    addressSelection: viewConfig.addressSelection,
    residenceVerification: viewConfig.residenceVerification,
    externalContact: viewConfig.externalContact,
    largeBrandLogo: viewConfig.secondaryLogoUrl,
  }
}

export function sanitizeProgramName(name: string) {
  if (name.endsWith('program') || name.endsWith('Program')) {
    name = name.replace('program', '')
    name = name.replace('Program', '')
  }
  return name
}
